














































































































































import { Vue, Component } from "vue-property-decorator";
import svgCalendar from "@/components/svg/svg-calendar.vue";
import svgClock from "@/components/svg/svg-clock.vue";
import { getModule } from "vuex-module-decorators";
import { SessionDataArray } from "@/types/interfaces";
import sessionVuexModule from "@/store/vuex-modules/getSessionData";
import UpcomingSessionItem from "@/components/sessions/UpcomingSessionItem.vue";
import layoutImagesVuexModule from "@/store/vuex-modules/layoutImages";
import SessionScheduleItem from "@/components/sessions/SessionScheduleItem.vue";
import Spinners from "@/components/utilities/Spinners.vue";
import PageTitleHeader from "@/components/shared/PageTitleHeader.vue";
import { format } from "date-fns";

const layoutImagesStore = getModule(layoutImagesVuexModule);
const sessionStore = getModule(sessionVuexModule);
// use b-modal if modal is needed - see PrerecordedListing.vue

@Component({
    components: {
        svgCalendar,
        UpcomingSessionItem,
        Spinners,
        svgClock,
        SessionScheduleItem,
        PageTitleHeader
    },
    filters: {
        maxCharacter(value: string) {
            return value.slice(0, 100) + "...";
        }
    }
})
export default class SessionSchedule extends Vue {
    templateAccessor = "";

    isLoading = true;
    selected = "";
    topicTitle = "";
    toggle = false;
    isSessionActive = false;
    sessionLabelInterval = 0;
    timeLabel = "";

    totalWidth = 0;
    loadClass = true;

    toggleFavorite(): boolean {
        return !this.toggle;
    }

    showModal(title: string) {
        this.topicTitle = title;
        console.log(this.topicTitle);
    }

    get layoutImageSchedule() {
        return layoutImagesStore.getLayoutImage("scheduleHeader");
    }

    get pageConfig() {
        return this.$store.getters.getPageOptions("schedule");
    }

    get pageDecorImage(): string {
        let returnValue = "";
        if (
            this.pageConfig.decorImages &&
            this.pageConfig.decorImages.pageBackground
        ) {
            returnValue = `${process.env.BASE_URL}bg/${this.pageConfig.decorImages.pageBackground}`;
        }
        return returnValue;
    }

    // get sessionDateTime() {
    //     const iso = this.session.startTimeISO;
    //     return new Date(iso);
    // }

    get tabsSchecdule() {
        const dateString = format(window.MgServerTime, "yyyy-MM-dd");
        //serve as tablist
        const tabList = this.sessions.map((tab) => {
            return Vue.prototype.MgFormatISODateTime(
                tab.startTimeISO,
                "mm-dd-yyyy"
            );
        });

        //remove Duplicate date
        const filteredDate = [...new Set(tabList)];

        //active tab
        const dateIndex = filteredDate.findIndex((item: any) => {
            return item === dateString;
        });

        this.selected = dateIndex >= 0 ? tabList[dateIndex] : tabList[0];

        return filteredDate;
    }

    get cssVariables() {
        return this.$store.getters.cssVariables;
    }

    created() {
        sessionStore
            .getSessionData({
                tableName: this.$store.getters.awsConfig.sessionTable,
                isDemoData: false
            })
            .finally(() => {
                this.isLoading = false;
            });

        this.templateAccessor = this.$route.meta.title;
    }

    get sessions(): SessionDataArray {
        if (sessionStore.sessionData.upcomingSessions.length != 0) {
            return sessionStore.sessionData.upcomingSessions;
        }

        return sessionStore.sessionData.onDemand;
    }

    //Group session by time slot
    get sessionData(): SessionDataArray {
        if (this.sessions) {
            return this.sessions
                .filter((data) => {
                    return (
                        Vue.prototype.MgFormatISODateTime(
                            data.startTimeISO,
                            "mm-dd-yyyy"
                        ) === this.selected
                    );
                })
                .reduce((prev: any, nxt: any) => {
                    prev[nxt.startTimeISO] = [
                        ...(prev[nxt.startTimeISO] || []),
                        nxt
                    ];
                    return prev;
                }, {});
        }
        return [];
    }

    get sortedSession() {
        return Object.keys(this.sessionData)
            .sort()
            .reduce((result: any, key: any) => {
                result[key] = this.sessionData[key];
                return result;
            }, {});
    }

    get detectUserTimeZone() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    //method
    parseTimeToISO = (timeStart: string, timeEnd: string) => {
        const newTimeS = Vue.prototype.MgFormatISODateTime(timeStart, "time");
        const newTimeE = Vue.prototype.MgFormatISODateTime(timeEnd, "time");

        return newTimeS + " - " + newTimeE;
    };

    updated() {
        this.totalWidth = 0;
        const elContainer = document.querySelector("#button-tab-container")!;
        const innerEl = elContainer.getElementsByTagName("button");
        const activeEl = document.querySelector(
            "button.is-active"
        ) as HTMLButtonElement;

        Object(innerEl).forEach(
            (item: any) => (this.totalWidth += item.offsetWidth)
        );

        if (elContainer != null && activeEl != null) {
            this.$nextTick(() => {
                const marginLeft = activeEl.offsetLeft;
                const elWidth = activeEl.offsetWidth;
                const screenSize = screen.width;

                // console.log(activeEl.key);

                if (this.totalWidth > 1024) {
                    elContainer.classList.remove("justify-center");
                }
                if (marginLeft < this.totalWidth / 2) {
                    elContainer.scrollLeft = 0;
                } else {
                    if (screenSize <= 1280) {
                        elContainer.scrollLeft =
                            marginLeft - (screenSize / 2 - elWidth / 2);
                    } else if (screenSize < 1980) {
                        elContainer.scrollLeft =
                            marginLeft - screenSize / 2 + elWidth;
                    } else if (screenSize <= 2400) {
                        elContainer.scrollLeft =
                            marginLeft - screen.width / 4 - 52;
                    } else if (screenSize > marginLeft) {
                        elContainer.scrollLeft =
                            marginLeft - screenSize / 4 + elWidth / 2;
                    }
                }
            });
        }
    }
}
